import { FlexRow } from "components/Flex";
import RootStore from "stores/RootStore";
import { Spacer } from "components/Spacer";
import { DialogButton } from "components/Button";
import { Info } from "@mui/icons-material";
import Checkbox from "@mui/material/Checkbox";
import ProductionScheduleStore from "../ProductionScheduleStore";
import { computed } from "mobx";
import { observer } from "mobx-react";

type Status =
  | "new"
  | "modeled"
  | "drawn"
  | "checked"
  | "issued for construction";

interface EntityProps {
  id: number;
  controlNumber: string;
  markNumber: string;
  castingDate: string;
  jobNumber: number;
}

interface ProductionScheduleRightBodyCellCellEntityProps {
  entity: EntityProps;
  rowIndex: number;
  rootStore?: RootStore;
  style?: React.CSSProperties;
}

const ProductionScheduleRightBodyCellCellEntity = observer(
  (props: ProductionScheduleRightBodyCellCellEntityProps) => {
    // trace();
    // console.log('ProductionScheduleRightBodyCellCellEntity props', props);
    const entity = props.entity as EntityProps;
    // const buttonColor = 'transparent';
    // console.log('style', props.style);
    const { rootStore } = props;
    const productionScheduleStore =
      rootStore?.productionScheduleStore as ProductionScheduleStore;
    // console.log('productionScheduleStore', productionScheduleStore);

    const width = props?.style?.width as number;
    const allStatuses: Status[] = [
      "new",
      "modeled",
      "drawn",
      "checked",
      "issued for construction",
    ];
    const drawingStatus: Status =
      allStatuses[
      Math.floor(parseFloat(entity.controlNumber) % allStatuses.length)
      ];
    const statusColor = {
      new: "gray",
      modeled: "blue",
      drawn: "orange",
      checked: "orange",
      "issued for construction": "green",
    }[drawingStatus];

    const currentEntityIsSelected = computed(() =>
      productionScheduleStore.currentlySelectedEntities.includes(entity.id)
    ).get();

    return (
      <div
        key={entity.id}
        style={{
          height: 42,
          width: width - 8,
          border: `2px solid ${statusColor}`,
          borderRadius: 4,
          margin: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "white",
        }}
      >
        <FlexRow style={{ width: width - 4 }}>
          {/* <StatusCircle status={drawingStatus} /> */}
          <Checkbox
            checked={currentEntityIsSelected}
            onChange={() => {
              console.log("Checkbox clicked");
              productionScheduleStore.setCurrentlySelectedEntities(entity.id);
            }}
          // sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
          />
          <Spacer />

          <span style={{ display: "flex", alignItems: "center" }}>
            <b>{`${entity?.controlNumber} - ${entity?.markNumber}`}</b>
          </span>

          <Spacer />
          <DialogButton
            justIcon
            color="transparent"
            dialogName="panelDetails"
            dialogContext={entity.id.toString()}
          >
            <Info />
          </DialogButton>
        </FlexRow>
      </div>
    );
  }
);

export default ProductionScheduleRightBodyCellCellEntity;
